import { useFormHistoryWithOffline } from "app/features/offline/hooks/useFormHistoryWithOffline";
import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import {
  NewFormButtonText,
  FormEnums,
} from "app/services/api/types/forms/enums/FormEnums";
import { View } from "react-native";
import { NoItemsComponent } from "ui/atoms/noItems";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { ButtonLink, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { AddIcon } from "ui/gluestack/icon";
import { AssessmentEntryEditProvider } from "../../assessments/providers";
import { AssessmentHeader } from "../molecules/AssessmentHeader";
import { AssessmentPreview } from "../molecules/AssessmentPreview";
import { AssessmentActions } from "../molecules/AssessmentActions";
import {
  DefaultAssessmentEntryActions,
  VersionedEntryActions,
} from "../actions";
import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { useRouter } from "expo-router";
import { AssessmentVersionedHistoryTemplate } from "./AssessmentVersionedHistoryTemplate";

const AssessmentEntryPreview = ({
  form,
  fillLink,
  versioned,
}: {
  form: SubmittedFormModel;
  fillLink: string;
  versioned?: boolean;
}) => {
  const router = useRouter();

  return (
    <View>
      <View className="flex-row justify-between items-start mb-5">
        <AssessmentHeader assessment={form} />
      </View>
      <View>
        <AssessmentPreview submittedForm={form} />
        <AssessmentActions
          assessment={form}
          actions={
            versioned ? VersionedEntryActions : DefaultAssessmentEntryActions
          }
          props={{
            onPress: () => {
              router.push(fillLink);
            },
          }}
        />
      </View>
    </View>
  );
};

interface Props {
  tag: FormEnums;
  noEntryTitle?: string;
  fillLink: string;
  versioned?: boolean;
}
export function AssessmentSingleEntryTemplate({
  tag,
  noEntryTitle,
  fillLink,
  versioned,
}: Props) {
  const { resident } = useResidentContext();
  const { data, isLoading } = useFormHistoryWithOffline({
    tag,
    residentId: resident?.id,
  });
  const lastEntry = data?.[0];

  return (
    <AssessmentEntryEditProvider>
      {isLoading ? (
        <View className="flex-1 justify-center items-center my-5">
          <LoadingSpinner />
        </View>
      ) : lastEntry ? (
        <AssessmentEntryPreview
          form={lastEntry}
          fillLink={fillLink}
          versioned={versioned}
        />
      ) : (
        <View>
          <NoItemsComponent className="pt-5 pb-8" title={noEntryTitle} />
          <ButtonLink href={fillLink} className="self-center">
            <ButtonIcon as={AddIcon} />
            <ButtonText>{NewFormButtonText[tag] || "Create Entry"}</ButtonText>
          </ButtonLink>
        </View>
      )}

      {lastEntry && resident && (
        <View className="mt-5">
          <AssessmentVersionedHistoryTemplate
            tag={tag}
            residentId={resident.id}
            excludeEntryId={lastEntry.id}
          />
        </View>
      )}
    </AssessmentEntryEditProvider>
  );
}
